import { Flex, Box } from '@chakra-ui/react'

export const Pulsar = () => (
  <Flex alignItems={'center'} justifyContent={'center'} flexShrink={0} w={6} h={4}>
    <Flex
      sx={{
        ' @keyframes pulsateShadow': {
          '0%': {
            boxShadow: '0px 0px 0px #8E83FB',
          },
          '100%': {
            boxShadow: '0px 0px 10px #8E83FB',
          },
        },
      }}
      animation={'pulsateShadow 0.5s infinite alternate'}
      boxShadow={'0px 0px 10px #8E83FB'}
      rounded={'full'}
      w={5}
      h={5}
      bg={'linear-gradient(292deg, rgba(142, 131, 251, 0.40) 31.11%, rgba(93, 82, 238, 0.40) 97.01%);'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      <Flex
        w={3}
        h={3}
        rounded={'full'}
        bg={'linear-gradient(292deg, rgba(142, 131, 251, 0.60) 31.11%, rgba(93, 82, 238, 0.60) 97.01%);'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Box rounded={'full'} bg={'white'} w={1} h={1} />
      </Flex>
    </Flex>
  </Flex>
)
